<template>
  <b-nav-item-dropdown
      class="dropdown-notification mr-25"
      menu-class="dropdown-menu-media"
      right
  >
    <template #button-content>
      <feather-icon
          :badge="$store.state.roomReservation.reservations.length"
          badge-classes="bg-danger"
          class="text-body"
          icon="BookOpenIcon"
          size="21"
      />
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">
          درخواست اتاق جلسه
        </h4>
        <b-badge
            pill
            variant="light-primary"
            v-show="$store.state.roomReservation.reservations.length"
        >
          {{ $store.state.roomReservation.reservations.length }} جدید
        </b-badge>
      </div>
    </li>

    <!-- Notifications -->
    <vue-perfect-scrollbar
        :settings="perfectScrollbarSettings"
        class="scrollable-container media-list scroll-area"
        tagname="li"
    >
      <b-link
          v-for="reservation in $store.state.roomReservation.reservations"
          :key="reservation.id"
          :to="gerReservationRoute(reservation)"
      >
        <b-media>
          <p class="media-heading">
            <span class="font-weight-bolder">
              {{ reservation.title }}
            </span>
          </p>
          <small><b-badge
              :variant="reservation.status.label"
              class="mr-1"
          >
            {{ reservation.status.title }}
          </b-badge></small>
        </b-media>
      </b-link>

    </vue-perfect-scrollbar>

  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BBadge, BMedia, BLink, BAvatar, BButton, BFormCheckbox,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import store from "@/store";
import {getUserData} from "@/auth/utils";
import {doubleRaf} from '@/libs/utils'


export default {
  name: "RoomReservationNavBar",
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      reservations: [],
      perfectScrollbarSettings: {
        maxScrollbarLength: 60,
        wheelPropagation: false,
      }
    }
  },

  methods: {
    gerReservationRoute(reservation) {
      if (reservation.isAdmin) {
        return {name: 'RoomReservation_AdminEdit', params: {id: reservation.id}}
      } else {
        return {name: 'RoomReservation_List'}
      }
    },
    getTickets() {
      doubleRaf(() => {
        this.$http.get(`room-reservations/notification`)
            .then(({data}) => {
              store.commit('roomReservation/ADD_RESERVATION_TO_LIST', data)

            })
      })

    },
    async listen() {
      const router = this.$router
      setTimeout(() => {
        this.$echo
            .channel(`room.reservation.${this.$store.state.user.data.id}`)
            .listen('.RoomReservationEvent', (data) => {
              const reservations = this.$store.state.roomReservation.reservations
              reservations.unshift(data)
              store.commit('roomReservation/ADD_RESERVATION_TO_LIST', reservations)

              this.$bvToast.toast(data.content, {
                title: data.title,
                variant: 'info',
                toaster: 'b-toaster-top-left'
              })
              this.$notification.show(data.title, {
                body: data.content ?? ''
              }, {
                onclick: function () {
                  router.push({name: 'RoomReservation_AdminEdit', params: {'id': data.id}})
                },
              })
            });

      }, 3000)

    },
  },

  mounted() {
    this.getTickets()
    this.listen()
  }
}
</script>

<style>

</style>
